import { render, staticRenderFns } from "./MyNotStartedLandownerReports.vue?vue&type=template&id=4346da0d"
import script from "./MyNotStartedLandownerReports.vue?vue&type=script&lang=js"
export * from "./MyNotStartedLandownerReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports